const calendarBreadcrumb = (data) => {
  const { breadcrumb } = data || {}

  return ['CALENDAR', breadcrumb === 'create' ? 'CREATE' : '']
}

export default calendarBreadcrumb
